import gql from 'graphql-tag'

export const ME_QUERY = gql`
  query User {
    me {
      id
      firstName
      lastName
      displayName
      primaryEmail
      type
      photo
    }
  }
`
